import { IconButton } from "@circleco/compass/components/IconButton";

import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface ConnectIconButtonsProps {
  className?: string;
  flexDirection?: "flex-row" | "flex-row-reverse";
  handleAccept: () => void;
  handleIgnore: () => void;
  isAccepting: boolean;
  isIgnoring: boolean;
}

export const ConnectIconButtons = ({
  className,
  flexDirection,
  handleAccept,
  handleIgnore,
  isAccepting,
  isIgnoring,
}: ConnectIconButtonsProps) => (
  <div className={classNames("flex gap-2 w-fit", flexDirection, className)}>
    <IconButton
      variant="primary"
      size="sm"
      icon="checkmark"
      aria-label={t("member_directory.accept")}
      loading={isAccepting}
      disabled={isIgnoring}
      onClick={handleAccept}
      data-testid="accept-button"
    />
    <IconButton
      variant="outline"
      size="sm"
      icon="cross"
      aria-label={t("member_directory.ignore")}
      loading={isIgnoring}
      disabled={isAccepting}
      onClick={handleIgnore}
      data-testid="ignore-button"
    />
  </div>
);
